export default "__VITE_ASSET__DcTm3RY0__"